module.exports = __webpack_public_path__ + "img/icon_mall_arr_prev.99b39bf5.svg";